//import React from 'react'
//import { Outlet, Link, NavLink } from "react-router-dom";
//import { useState, useEffect } from "react"
import "98.css";

export default function DiscoonNeptune() {

    return (
        <>

        <p>Gypsy women come back to me<br></br>
        I wanna be your everything<br></br>
        I wanna walk you to the sun<br></br>
        Back to back and our soul is one<br></br>
        And I keep it burning<br></br>
        And I keep it burning<br></br>
        And I keep it burning<br></br>
        And I keep it<br></br>
        <br></br>
        Gypsy women come back to us<br></br>
        I wanna be the one you trust<br></br>
        I wanna take, I wanna give<br></br>
        I wanna see what's left to live<br></br>
        And I keep it burning<br></br>
        And I keep it burning<br></br>
        And I keep it burning<br></br>
        And I keep it<br></br>
        <br></br>
        I hid what I knew<br></br>
        Like I didn’t know the truth<br></br>
        When you asked me what’s next<br></br>
        At the overview effect<br></br>
        I waited on time<br></br>
        For the planets to align<br></br>
        I’ll never understand<br></br>
        How I let you get into the wrong hands<br></br>
        <br></br>
        Gypsy women come back to me<br></br>
        So we can be an entity<br></br>
        We can save this love affair<br></br>
        We took the world with none to spare<br></br>
        And I keep it burning<br></br>
        And I keep it burning<br></br>
        And I keep it burning<br></br>
        And I keep it<br></br>
        <br></br>
        Said you’re coming from a car crash<br></br>
        With the weight of the world<br></br>
        I want you that way<br></br>
        When you’ve lost control<br></br>
        You said<br></br>
        <br></br>
        How was I to know<br></br>
        You’re hiding something<br></br>
        How was I to know<br></br>
        You’re hiding something<br></br>
        <br></br>
        They’ll take you away<br></br>
        I’m hung up on this world<br></br>
        They’ll take you away<br></br>
        I know, I know<br></br>
        <br></br>
        Gypsy women come back to me<br></br>
        I wanna be your everything<br></br>
        I wanna walk you to the sun<br></br>
        Back to back and our soul is one<br></br>
        And I keep it burning<br></br>
        And I keep it burning<br></br>
        And I keep it burning<br></br>
        And I keep it<br></br>
        <br></br>
        I hid what I knew<br></br>
        Like I didn’t know the truth<br></br>
        When you asked me what’s next<br></br>
        At the overview effect<br></br>
        I waited on time<br></br>
        For the planets to align<br></br>
        I’ll never understand<br></br>
        How I let you get into the wrong hands</p>

        </> 
    )
}